import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import useAppMutation from 'hooks/useAppMutation';
import useAppUser from 'hooks/useAppUser';
import useNotify from 'hooks/useNotify';
import API from 'services/API';
import { DBS_SETTINGS_BASE_QUERY_KEY } from '../useFetchDbsSettings';

export const AGENCY_HERO_URL = '/api/internal/photos/agency-hero';

interface UploadAgencyHeroResponseTO {
  fileName: string;
  uid: string;
}

const useUploadAgencyHeroMutation = () => {
  const { agencyUid } = useAppUser();
  const { notifyError, notifySuccess } = useNotify();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useAppMutation({
    mutationFn: async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await API.post<UploadAgencyHeroResponseTO>(
        AGENCY_HERO_URL,
        formData,
      );

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries([
        DBS_SETTINGS_BASE_QUERY_KEY,
        agencyUid,
      ]);
      notifySuccess(t('pageDirectBookingEngine.websiteSettings.heroSaved'));
    },
    onError: () => {
      notifyError(t('pageDirectBookingEngine.websiteSettings.heroUploadError'));
    },
  });
};

export default useUploadAgencyHeroMutation;
